// Translation key for a validation error's field path.
//
// Paths come from the API normalized by ViolationPath::display(): collection indices are
// dropped and the leaf field is kept, so "translations[0].name" arrives as
// "translations.name". They map onto keys under this prefix.
export const validationFieldLabelId = (path) =>
    `retailer.product.list.validation.field.${path}`;

// Whether a validation error list is worth a tooltip.
//
// A product or variation can be invalid with NO error to show: the API's verdict is not
// "zero violations" — an entity with none of its own is still invalid when none of its
// variations passes, or when its retailer option values are inconsistent. The KO tag then
// carries no tooltip rather than an empty one.
export const hasValidationErrors = (validationErrors) => {
    if (Array.isArray(validationErrors)) {
        return validationErrors.length > 0;
    }

    // Rows coming from the REST collection instead of Elasticsearch carry the flattened
    // string ProductNormalizer publishes, which is rendered as-is.
    return Boolean(validationErrors);
};
